export default __webpack_public_path__ + "static/media/reboot_button.3359ff8b.png";